import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
function EmailRefresh(_ref) {
  let {
    color = '#335B70',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M4.572 3.937c-1.41 0-2.54 1.13-2.54 2.54v15.238c0 1.41 1.143 2.54 2.54 2.54h13.333c-0.419-1.006-0.635-2.085-0.635-3.175 0-2.189 0.87-4.288 2.418-5.837s3.647-2.417 5.837-2.417c0.642 0.002 1.281 0.079 1.905 0.229v-6.578c0-1.41-1.143-2.54-2.54-2.54h-20.317zM4.572 6.476l10.159 6.349 10.159-6.349v2.54l-10.159 6.349-10.159-6.349v-2.54zM24.889 14.095l-2.857 2.857 2.857 2.857v-1.905c1.752 0 3.175 1.422 3.175 3.175 0 0.508-0.114 0.99-0.33 1.422l1.384 1.384c0.533-0.8 0.851-1.765 0.851-2.806 0-2.806-2.273-5.079-5.079-5.079v-1.905zM20.661 18.273c-0.533 0.8-0.851 1.765-0.851 2.806 0 2.806 2.273 5.079 5.079 5.079v1.905l2.857-2.857-2.857-2.857v1.905c-1.752 0-3.175-1.422-3.175-3.175 0-0.508 0.114-0.99 0.33-1.422l-1.384-1.384z"
  })));
}
export default EmailRefresh;